<script lang="ts" setup>
import { IconStatusErroredOutline } from '@cypress-design/vue-icon'
</script>

<template>
  <div class="mt-[8px] flex items-center text-[14px] leading-[20px] text-red-600">
    <IconStatusErroredOutline stroke-color="red-400" class="mr-[8px] inline-block" />
    <slot />
  </div>
</template>
